const config = {
  appFetch: {
    get: async ({ url }) => {
      try {
        const resp = await fetch(url);
        const data = await resp.json();

        return data;
      } catch (error) {
        console.error("Error", error);
      }
    },
    post: async ({ url, method = "POST", body }) => {
      try {
        const resp = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });

        const data = await resp.json();
        return data;
      } catch (error) {
        console.error("Error", error);
      }
    },
  },
};

export default config;
